import { globalAxios } from "@/axios-path.js";

export default {
    namespaced: true,
    state: {
        baseDistanceList: []
    },
    mutations: {
        setBaseDistanceList(state, data) {
            state.baseDistanceList = data.sort((a, b) => b.distance_id - a.distance_id)
        },
    },
    actions: {
        async createBaseDistanceOld({ commit, dispatch, rootState }, { form, province }) {
            for (let val of form.distance_text) {
                val.transport_charge_start = parseFloat(val.transport_charge_start)
                val.transport_charge_end = parseFloat(val.transport_charge_end)
                val.transport_charge_price = parseFloat(val.transport_charge_price)
            }

            let url = `/api/v1/${province}/create/distanceBase`;
            try {
                let res = await globalAxios.post(url, form);
                if (typeof res.msg == "boolean" && res.msg == false) {
                    return false;
                } else {
                    commit("setBaseDistanceList", res.data);
                    return true;
                }
            } catch (error) {
                return false;
            }
        },
        async getBaseDistanceList({ commit, dispatch, rootState }, province) {
            let url = `/api/v1/${province}/list/distanceBases`;
            try {
                let res = await globalAxios.get(url);
                if (typeof res.msg == "boolean" && res.msg == false) {
                    return [];
                } else {
                    commit('setBaseDistanceList', res.data);
                    return res.data;
                }
            } catch (error) {
                return [];
            }
        },
        async fetchBaseDistance({ }, { distance_type, province }) {
            let url = `/api/v1/service/${province}/${distance_type}/list/distanceBases`;
            try {
                let res = await globalAxios.get(url);
                if (typeof res.msg == "boolean" && res.msg == false) {
                    return false;
                } else {
                    return res.data;
                }
            } catch (error) {
                return false;
            }
        },
        async updateBaseDistance({ }, { distance_type, province, distance_id, payload }) {
            for (let val of payload.distance_text) {
                val.transport_charge_end = parseFloat(val.transport_charge_end);
                val.transport_charge_price = parseFloat(val.transport_charge_price);
                val.transport_charge_start = parseFloat(val.transport_charge_start);
            }

            if (payload.distance_district == null) {
                payload.distance_district = [];
            }

            if (payload.distance_store == null) {
                payload.distance_store = [];
            }
            let url = `/api/v1/service/${province}/${distance_type}/edit/distanceBase/${distance_id}`;
            try {
                let res = await globalAxios.put(url, payload);
                if (typeof res.msg == "boolean" && res.msg == false) {
                    return false;
                } else {
                    return res.data;
                }
            } catch (error) {
                return false;
            }
        },
        async createBaseDistance({ }, { distance_type, province, payload }) {
            for (let val of payload.distance_text) {
                val.transport_charge_end = parseFloat(val.transport_charge_end);
                val.transport_charge_price = parseFloat(val.transport_charge_price);
                val.transport_charge_start = parseFloat(val.transport_charge_start);
            }

            if (payload.distance_district == null) {
                payload.distance_district = [];
            }

            if (payload.distance_store == null) {
                payload.distance_store = [];
            }

            let url = `/api/v1/service/${province}/${distance_type}/create/distanceBase`;
            try {
                let res = await globalAxios.post(url, payload);
                if (typeof res.msg == "boolean" && res.msg == false) {
                    return false;
                } else {
                    return res.data;
                }
            } catch (error) {
                return false;
            }
        }
    }
};